import Button from "app/components/button/button";
import CircleLoader from "app/components/loader/CircleLoader";
import { TGLink } from "app/config";
import useAppNavigation from "app/hooks/useAppNavigate";
import { useTheme } from "app/shared";
import telegram from "assets/img/icons/tgWhite.svg";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { useFindByIdQuery } from "store/api/new.api";
import { useAccount } from "wagmi";
import SocialIcons from "../social-icons/social-icons";
import styles from "./project-overview-widget.module.scss";

interface ProjectOverviewWidgetProps {
  stage?: "whitelist" | "swap" | "fcfs";
  isLoading: boolean;
  link?: string;
}

const ProjectOverviewWidget: FC<ProjectOverviewWidgetProps> = ({
  stage,
  link,
  isLoading,
}) => {
  const { idoId } = useParams<{ idoId: string }>();
  const { data: ido, isLoading: idoIsLoading, error } = useFindByIdQuery(idoId);
  const { address } = useAccount();
  const { navigateToLink } = useAppNavigation();
  const { theme } = useTheme();

  if (idoIsLoading || isLoading) {
    return <CircleLoader />;
  }

  if (error || !ido) {
    return <p className={styles.error}>Failed to load project details.</p>;
  }

  return (
    <div
      className={`${styles.widget} ${theme === "dark" ? styles.darkTheme : ""}`}
    >
      <div className={styles.content}>
        <div
          className={`${styles.logoWrapper} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
        >
          <img
            src={ido.media?.find((m: any) => m.label === "logo")?.value || ""}
            alt={`${ido.title} logo`}
            className={styles.logo}
          />
          {/* <div className={styles.badge}>EXAMPLE</div> */}
        </div>
        <div className={styles.wrapper}>
          <h3 className={styles.title}>{ido.name}</h3>
          <p className={styles.description}>{ido.description}</p>
          <div className={styles.linkWrapper}>
            <Button
              className={styles.btn}
              variant="gradient"
              onClick={navigateToLink(`${TGLink}${address}`)}
            >
              Track in the Telegram Bot
              <img src={telegram} alt="tg icon" />
            </Button>
            <SocialIcons links={ido.frontEndData[4].socialLinks} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectOverviewWidget;
